export function Skeleton({ className = '', style = {} }) {
  return <div className={`animate-pulse rounded bg-surface2 ${className}`} style={style} />
}

export function MangaCardSkeleton() {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className="w-full rounded-lg" style={{ aspectRatio: '2/3' }} />
      <Skeleton className="h-4 w-3/4 rounded" />
      <Skeleton className="h-3 w-1/2 rounded" />
    </div>
  )
}

